module.exports = __webpack_public_path__ + "img/would you like one.fd841dc1.png";